import React from "react";

class Settings extends React.Component {
    constructor(props) {
        super(props);

        this.open.bind(this);
        this.state = {
            wordLength: props.wordLength,
            maxGreen: props.maxGreen,
            maxYellow: props.maxYellow,
            changed: false,
        }
    }

    componentDidMount() {
        this.props.openSettings(this.open);
    }

    open() {
        var modal = document.getElementsByClassName("settings-menu")[0];
        modal.setAttribute("data-animation", "in");
        modal.style.display = "block";
    }

    close() {
        var modal = document.getElementsByClassName("settings-menu")[0];
        modal.setAttribute("data-animation", "out");
        if (this.state.changed) {
            this.props.setParameters(this.state.wordLength, this.state.maxGreen, this.state.maxYellow);
            this.setState({ changed: false });
        }
        setTimeout(() => modal.style.display = "none", 400);
    }

    setWordLength() {
        var word_length = document.getElementById("word-length-slider").value;
        this.setState({
            wordLength: word_length,
            maxGreen: Math.min(word_length, this.state.maxGreen),
            maxYellow: Math.min(word_length, this.state.maxYellow),
            changed: true,
        });
        document.getElementById("max-green-slider").max = this.state.wordLength;
        document.getElementById("max-yellow-slider").max = this.state.wordLength;
    }

    render() {
        return (
            <div id="settings-menu" className="settings-menu">
                <div>
                    <div className="settings-title">Settings</div>
                    <span className="close" onClick={this.close.bind(this)}>&times;</span>
                </div>
                <div className="settings-body">
                    <div className="setting-box">
                        Word Length: {this.state.wordLength}
                        <input type="range" min="2" max="10" defaultValue={this.state.wordLength} className="slider" id="word-length-slider" onChange={() => this.setWordLength()}></input>
                    </div>
                    <div className="setting-box">
                        Maximum Green Letters: {this.state.maxGreen}
                        <input type="range" min="0" max={this.state.wordLength} defaultValue={this.state.maxGreen} className="slider" id="max-green-slider" onChange={() => this.setState({ maxGreen: document.getElementById("max-green-slider").value, changed: true })}></input>
                    </div>
                    <div className="setting-box">
                        Maximum Yellow Letters: {this.state.maxYellow}
                        <input type="range" min="0" max={this.state.wordLength} defaultValue={this.state.maxYellow} className="slider" id="max-yellow-slider" onChange={() => this.setState({ maxYellow: document.getElementById("max-yellow-slider").value, changed: true })}></input>
                    </div>
                </div>
                <div className="settings-footer">
                    <a href="https://docs.google.com/spreadsheets/d/11pzVQeTLGJFsJIaf7NVimiWTkb3U22oBH6MUgOLJHPI" target="_blank" rel="noreferrer">Issue Tracker</a>
                </div>
            </div>
        );
    }
}

export default Settings;